import React from 'react';
import Lottie from 'lottie-react';
import animationData from '~go/web/html/d/images/external_pages/landing/section-1/gosearch-landing-hero.json';

function Section1Hero() {
  return <Lottie animationData={animationData} loop  />;
}

export default Section1Hero;
